import { Injectable } from '@angular/core';
import { LocalStorageService } from 'angular-2-local-storage';
import { CookieService } from 'ngx-cookie-service';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';

@Injectable()
export class CacheService {
    cookieService: CookieService = new CookieService(document);
    constructor(private _localStorageService: LocalStorageService) { }

    /**
     * get the value from storage for pair of key
     * @param  {string} cacheKey
     */
    public  get(cacheKey: string):any {
        if (cacheKey) {
            return this._localStorageService.get(cacheKey);
        }
    }


    /**
     * save the value into storage with pair of key
     * @param  {string} cacheKey
     */
    public set(cacheKey: string, cacheValue: any): void {
        if (cacheKey && cacheValue) {
            this._localStorageService.set(cacheKey, cacheValue);
        }
    }

    /**
     * remove the value form storage
     * @param  {string} cacheKey
     */
    public remove(cacheKey: string): void {
        if (cacheKey) {
            this._localStorageService.remove(cacheKey);
        }
    }

    /**
     * remove the value form storage
     * @param  {string} cacheKey
     */
    public removeAll(isValid: boolean): void {
        if (isValid) {
            this._localStorageService.clearAll();
        }
    }

       /**
 * get the value from cookie storage for pair of key
 * @param  {string} cacheKey
 */
public getCookieValue(cacheKey: string): any {
    if (cacheKey) {
        return this.cookieService.get(cacheKey);
    }
}

 /**
     * @returns any
     */
    public getSessionValue(cacheKey: string): any {
        if (cacheKey) {
            return JSON.parse(sessionStorage.getItem(cacheKey));
        }
    }

    /**
     * @returns any
     */
    public setSessionValue(cacheKey: string, cacheValue: any): any {
        if (cacheKey) {
            return sessionStorage.setItem(cacheKey, JSON.stringify(cacheValue));
        }
    }

    /**
     * @returns any
     */
    public removeSessionValue(cacheKey: string): void {
        if (cacheKey) {
            sessionStorage.removeItem(cacheKey);
        }
    }

}


// WEBPACK FOOTER //
// ./src/app/shared/services/cache.service.ts